import React, { useState } from "react";
import styles from "./styles";
import { TextField, FormControl, MenuItem, Box, Select, Button } from "@mui/material";
import SendIcon from '@mui/icons-material/Send';

const Reservation = function Reservation(props) {
  console.log("Chargement du composant Reservation");

  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [convives, setConvives] = useState(2);

  const handleDateChange = (event) => {
    setDate(event.target.value);
  };

  const handleTimeChange = (event) => {
    setTime(event.target.value);
  };

  const handleConvivesChange = (event) => {
    setConvives(event.target.value);
  };

  const handleSubmit = async () => {
    if (!date || !time) {
      console.log("Date et heure sont obligatoires.");
      return;
    }

    const datetime = `${date} ${time}`;
    const id = Date.now();

    const name = "CANEVET-DANOIS";
    const amount = convives;

    const reservationData = {
      id,
      name,
      datetime,
      amount,
    };

    try {
      const response = await fetch("https://bbessere.lpmiaw.univ-lr.fr/resto/resto.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",  // Envoi des données en JSON
        },
        body: JSON.stringify(reservationData), // Conversion de l'objet en JSON
      });

      if (response.ok) {

        const result = await response.json();
        if (result === 0){
          alert("Reservation échouée")
        }
        else{
          alert("Reservation réussie !")
        }
        console.log("Réservation envoyée avec succès:", result);
      } else {
        alert("Reservation échouée")
        console.error("Erreur lors de l'envoi de la réservation:", response.status);
      }
    } catch (error) {
      console.error("Erreur de connexion:", error);
    }
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Reservation</h1>
      
      <p>Sélectionnez une date :</p>
      <TextField
        type="date"
        value={date}
        onChange={handleDateChange}
        style={{ backgroundColor: "white", borderRadius: "4px", marginBottom: "10px" }}
      />

      <p>Sélectionnez une heure :</p>
      <TextField
        type="time"
        value={time} 
        onChange={handleTimeChange} 
        inputProps={{ step: 300 }} 
        style={{ backgroundColor: "white", borderRadius: "4px", marginBottom: "20px" }}
      />
  
      <p>Indiquez le nombre de convives : </p>
      <Box sx={{ minWidth: 120 }} style={{ backgroundColor: "white" }}>
        <FormControl fullWidth>
          <Select
            labelId="convives-select-label"
            id="convives-select"
            value={convives}
            onChange={handleConvivesChange}
            label="Convives"
          >
            {[...Array(12)].map((_, i) => (
              <MenuItem key={i + 1} value={i + 1}>
                {i + 1} {i + 1 === 1 ? "convive" : "convives"}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      <div style={{display: 'flex', justifyContent: 'center', padding:'1rem'}}>
        <Button 
          variant="contained" 
          color="primary" 
          onClick={handleSubmit} 
          style={{ marginTop: "20px", padding:'1rem' }}
        >
          <SendIcon style={{ marginRight: "8px" }} />
          Soumettre
        </Button>
      </div>
    </div>
  );
};

export default Reservation;
